export const CHECKLIST_ITEM_IDS = [
  "cache_responses",
  "token_budget",
  "billing_alarms",
  "load_test",
  "cdn_static",
  "async_writes",
  "review_reserved",
] as const;

export type ChecklistItemId = (typeof CHECKLIST_ITEM_IDS)[number];

export function defaultChecklist(): Record<ChecklistItemId, boolean> {
  return Object.fromEntries(CHECKLIST_ITEM_IDS.map((id) => [id, false])) as Record<
    ChecklistItemId,
    boolean
  >;
}

export function mergeChecklist(
  raw?: Record<string, boolean>,
): Record<ChecklistItemId, boolean> {
  const out = defaultChecklist();
  if (!raw) return out;
  for (const id of CHECKLIST_ITEM_IDS) {
    if (raw[id]) out[id] = true;
  }
  return out;
}
